export const SET_FEATURE_FLAG_STATE = 'ff/SET_FEATURE_FLAG_STATE';
